<template>
  <footer class="pt-2 pb-5 bg-dark text-white">
    <div class="container">
      <div class="row mt-2">
        <div class="col-12 text-muted text-center">
          Made especially for you by &copy;
          <a
            class="color-link"
            href="https://www.titusdecali.com"
            target="_blank"
          >
            <strong>Titus Decali</strong>
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>